<style lang="css">
 @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
 .navbar{
    height: 50px;
 }
.dropdown-item:active {
    background-color: #d6d6d6 !important;
 }
.dropdown-toggle::before,
.dropdown-toggle::after {
    border: none !important;
    content: none !important;
}
b.rainbow {
  background: linear-gradient(to right, cyan, violet);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
b.rainbow:hover {
  -webkit-text-fill-color: white !important;
}
footer {
 bottom: 0;
 width: 100%;
}
a.btn.btn-outline-primary.twit.btn-sm {
    color: rgba(255, 255, 255, 0.7);
    border-color: rgba(255, 255, 255, 0.5);
}
div.nvbar:hover {
    color: #ffffff !important;
    text-decoration: none;
}
a.footer-link:hover {
    color: #ffffff !important;
    text-decoration: none;
}
i.fa.fa-user-circle:hover {
    color: #ffffff !important;
    text-decoration: none;
}
a.dropdown-item:hover {
    color: rgba(0, 0, 0, 1) !important;
    text-decoration: none;
}
a.dropdown-item.active {
    color: rgba(0, 0, 0, 1) !important;
    text-decoration: none;
    background-color: rgba(0, 0, 0, 0.02) !important;
}
b#login:hover {
    color: #ffffff !important;
}
div#bottom-spacer.row{
    height: 7px !important;
}
div#top-spacer.row{
    height: 7px !important;
}
#app {
  margin-top: 0px;
}
#app-view {
  margin-top: 60px;
  min-height: calc(100vh - 230px);
}
div#nav_collapse.navbar-collapse.collapse.show {
    background: rgb(52, 58, 64);
    border: #949494;
    border-style: solid;
    border-width: thin;
    padding: 5px;
    z-index: 2!important;
}
div.navbar-brand.btn {
    background: rgb(52, 58, 64);
    padding: 5px;
    z-index: 2!important;
}
i.fa.fa-power-off:hover {
    color: #ff6271 !important;
    cursor: pointer;
}
div.dropdown-menu.dropdown-menu-right.show {
    background-color: #343a40;
}

</style>
<template>
    <div id="app">
        <b-navbar toggleable="md" type="dark" variant="dark">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-brand to="/">
                    <img src="./assets/unpacme_logo_grey.png" alt="HOME" class="d-inline-block align-top" width="50" height="50" >
                </b-navbar-brand>
                <b-navbar-nav>
                    <b-nav-item to="/"><b class="rainbow">UnpacMe</b></b-nav-item>
                    <!-- <b-nav-item v-if="authenticated" to="/account"><div class="nvbar"><i class="fa fa-user-circle"></i> Account</div></b-nav-item> -->
                    <b-nav-item v-if="authenticated" to="/history"><div class="nvbar"><i class="fa fa-bars"></i> History</div></b-nav-item>
                    <b-nav-item v-if="authenticated" to="/search"><div class="nvbar"><i class="fa fa-search"></i> Search</div></b-nav-item>
                    <b-nav-item to="/plans"><div class="nvbar"><i class="fa fa-shopping-cart"></i> Plans</div></b-nav-item>
                    <b-nav-item to="/feed"><div class="nvbar"><i class="fa fa-fire"></i> Live Feed</div></b-nav-item>
                    <b-nav-item target="_blank" href="https://api.unpac.me"><div class="nvbar"><i class="fa fa-cogs"></i> API</div></b-nav-item>
                    <b-nav-item target="_blank" href="https://oalabs.openanalysis.net/tag/unpacme/"><div class="nvbar"><i class="fa fa-bookmark"></i> Blog</div></b-nav-item>
                    <b-nav-item to="/about"><div class="nvbar"><i class="fa fa-info-circle"></i> About</div></b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <b-navbar-brand right class="btn" v-if="!authenticated" @click="login()">
                <b id="login" style="color:white;
                        font-family: Arial;
                        font-size: 1rem;
                        font-weight: 600;
                        line-height: 1.5;
                        color: rgba(255, 255, 255, 0.5);">Sign In</b>
            </b-navbar-brand>
            <!-- <b-navbar-brand right class="btn" v-if="authenticated">
                <i @click="logout()" style="color:#999da0" class='fa fa-power-off'></i>
            </b-navbar-brand> -->
<!--             <b-nav-item-dropdown v-if="authenticated" right class="navbar-brand active">
                <template slot="button-content">
                    <i style="color:#999da0" class='fa fa-power-off'></i>
                </template>
                <b-dropdown-item @click="logout()">Logout</b-dropdown-item>
            </b-nav-item-dropdown> -->
            <b-nav-item-dropdown v-if="authenticated" right class="navbar-brand active">
                <template slot="button-content">
                    <i style="color: rgba(162, 196, 247);" class='fa fa-user-circle'></i>
                </template>
                <b-dropdown-item style="color: white;" @click="gotoAccount()">Account</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  style="color: white;" @click="logout()">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar>
        <div id="app-view">
            <router-view
            :auth="auth"
            :authenticated="authenticated"
            :admin="admin">
          </router-view>
        </div>
        <!--footer class="bg-dark text-white mt-4" v-if="['Upload','Home','Results'].indexOf($route.name) > -1"-->
        <footer class="bg-dark text-white mt-4">
            <div class="container-fluid py-3">
            <b-row>
                <b-col class="col-md-4 text-left small align-self-start">
                    <b-row>
                        <b-col class="col-lg-8 text-left med align-self-start" style="color: rgba(255, 255, 255, 0.5);">
                            Powered by <a class="footer-link" href="https://www.openanalysis.net/" style="color: rgba(255, 255, 255, 0.7);"><b>OpenAnalysis</b></a>
                        </b-col>
                    </b-row>
                    <b-row v-if="!isMobile()">
                        <b-col class="col-lg-8 text-left small align-self-start">
                            <b-button :size="'sm'"   :variant="'outline-primary twit'" target="_blank" href="https://twitter.com/unpacme">
                                <span class="small">&nbsp;<i class="fa fa-twitter"></i>&nbsp; | Follow us @unpacme&nbsp;</span>
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row id="bottom-spacer">&nbsp;</b-row>
                    <b-row id="top-spacer">&nbsp;</b-row>
                </b-col>
                <b-col v-if="!isMobile()" class="col-md-4 text-center small align-self-center">
                    <b-row>
                        <b-col class="col-md-4 text-center small align-self-center"></b-col>
                        <b-col class="col-md-4 text-center small align-self-center" style="color: rgba(255, 255, 255, 0.5);">
                            <b>PUBLIC BETA</b><br>Release 5.0.1<br>
                        </b-col>
                        <b-col class="col-md-4 text-center small align-self-center"></b-col>
                    </b-row>
                    <b-row>&nbsp;</b-row>
                   <b-row id="bottom-spacer">&nbsp;</b-row>
                </b-col>
                <b-col class="col-md-4 text-right small align-self-end">
                    <b-row>
                        <b-col></b-col>
                        <b-col></b-col>
                        <b-col class="col-md-4 text-left med align-self-end">
                            <a class="footer-link" href="/tos" style="color: rgba(255, 255, 255, 0.7);">ToS</a>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col></b-col>
                        <b-col></b-col>
                        <b-col class="col-md-4 text-left med align-self-end">
                            <a class="footer-link" href="mailto:unpacme@openanalysis.net" style="color: rgba(255, 255, 255, 0.7);">Contact</a>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col></b-col>
                        <b-col></b-col>
                        <b-col class="col-md-4 text-left med align-self-end">
                            <a class="footer-link" href="/sitemap.html" style="color: rgba(255, 255, 255, 0.7);">Sitemap</a>
                        </b-col>
                    </b-row>
                    <b-row id="bottom-spacer">&nbsp;</b-row>
                    <b-row id="bottom-spacer">&nbsp;</b-row>
                    <b-row id="bottom-spacer">&nbsp;</b-row>
                </b-col>
            </b-row>
            </div>
        </footer>
    </div>
</template>

<script>
import AuthService from './auth/AuthService';

const auth = new AuthService();

const { login, signUp, logout, authenticated, admin, authNotifier } = auth;

export default {
    name: 'App',
    data() {
        authNotifier.on('authChange', (authState) => {
            this.authenticated = authState.authenticated;
            this.admin = authState.admin;
            // on any authentication change redirect to upload
            // this.$router.push({ path: `/upload` });
        });
        return {
            auth,
            authenticated,
            admin,
        };
    },
    methods: {
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            // ipad is a full browser
            // navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                return true;
            }
            return false;
        },
        gotoAccount() {
            // This is so stupid, vue won't close the dropdown
            // if we use to= so we have to use a stupid function
            window.location.href = '/account';
        },
        login,
        logout,
        signUp,
    },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue